/*
 * Copyright (c) Ing. Guillermo Valles Godoy 2020  ()
 *
 * $Date: 2020-08-01 :: 080120 (Sat, 01 Aug 2020) $
 * $Rev: 1.0 $
 */

new Vue({
    el: '#app_xpagos',
    data: {
        rut: ''
    },
    methods: {
        validar: function() {

            /************/
            var i = 0;
            var crdr = 0;
            var rutlong = this.rut;

            var rt = "";

            for(i=0;i<=rutlong.length;i++)
            {
                rt = this.rut.replace('.','');
                this.rut = rt;
            }

            for(i=0;i<=rutlong.length;i++)
            {
                rt = rt.replace('-','');
                this.rut = rt;
            }

            cr = rt.slice(0,-1);
            dr = rt.slice(-1).toUpperCase();

            if (cr != '')
            {
                crdr = 1;
                this.rut = cr + '-' + dr;
            }

            if (crdr == 1)
            {
                axios.post('validarlogin',{ rut: this.rut })
                .then( (response) => {
                    if(response.data.estado == 200 || response.data.estado == 100)
                    {
                        location.href = response.data.url;
                    }
                    else
                    {
                        Swal.fire({
                            position: 'center',
                            icon: response.data.icono,
                            title: response.data.texto,
                            showConfirmButton: false,
                            timer: 1700
                          })
                    }
                })
                .catch( (error) => {
                    console.log( error );
                });
            }

            if(this.rut.length==0)
            {
                Swal.fire('El campo rut es obligatorio...','','error');
            }

            return false;
            /***********/
        },
        pagar: function() {
            var total = document.getElementById('total_mostrar').innerText;
            var seleccion = document.getElementsByClassName('seleccion');
            var email_cliente = document.getElementById('exampleFormControlInput1').value;
            var forma_pago = seleccion[0].value;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(!re.test(email_cliente))
            {
              email_cliente = '';
            }
            let timerInterval
            Swal.fire({
            title: 'Atención',
            html: 'Luego de procesar el pago, debes esperar a ser redireccionado a XPAGOS para visualizar tu comprobante.',
            timer: 3000,
            timerProgressBar: true,
            onBeforeOpen: () => {
                Swal.showLoading()
                timerInterval = setInterval(() => {
                const content = Swal.getContent()
                if (content) {
                    const b = content.querySelector('b')
                    if (b) {
                    b.textContent = Swal.getTimerLeft()
                    }
                }
                }, 2000)
            },
            onClose: () => {
                clearInterval(timerInterval)
            }
            }).then((result) => {
                if (result.dismiss === Swal.DismissReason.timer) {
                    axios.post('create',{ forma_pago: forma_pago, email_cliente: email_cliente })
                    .then( (response) => {
                        if(response.data.estado != 200)
                        {
                            Swal.fire({
                                position: 'center',
                                icon: response.data.icono,
                                title: response.data.texto,
                                showConfirmButton: false,
                                timer: 1700
                              })
                        }
                        else
                        {
                            location.href = response.data.url;
                        }
                    })
                    .catch( (error) => {
                        Swal.fire({
                            position: 'center',
                            icon: 'error',
                            title: error,
                            showConfirmButton: false,
                            timer: 1700
                          })
                    });
                }
            })
        }
    }
});


 /*
 * Copyright (c) Ing. Guillermo Valles Godoy 2020  ()
 *
 * $Date: 2020-08-01 :: 080120 (Sat, 01 Aug 2020) $
 * $Rev: 1.0 $
 */
